export function Logos() {
  const companies = [
    'Accenture',
    'Deloitte', 
    'KPMG',
    'EY',
    'PwC',
    'McKinsey',
  ];

  return (
    <div className="bg-white py-16 px-4" data-testid="logos-section">
      <div className="max-w-7xl mx-auto">
        <p className="text-center text-sm text-gray-500 mb-8">
          Trusted by leading companies worldwide
        </p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
          {companies.map((company, index) => (
            <div key={index} className="flex items-center justify-center grayscale hover:grayscale-0 transition-all opacity-60 hover:opacity-100">
              <div className="text-xl text-gray-400 font-semibold">
                {company}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
